import React, { useState } from "react";
import { BootstrapModal } from "../BootstrapModal/Modal";
import { CgClose } from "react-icons/cg";
import Button from "../Button/Button";
import { useGetSingleLeaveReq } from "../../hooks/useManagement";

export const LeaveReqItemModal = ({ show, handleClose, item }) => {
  const [button] = useState(false);
  const { data, isLoading } = useGetSingleLeaveReq({
    leave_request_id: item?.IdLeaveRequest,
  });
  return (
    <BootstrapModal
      modaltitle="درخواست مرخصی"
      handleClose={handleClose}
      show={show}
      moreButton={button}
      size="md"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    ></BootstrapModal>
  );
};
